import errorMiddleware from './errorMiddleware';
import loggerMiddleware from './loggerMiddleware';
import serverTimingMiddleware from './serverTimingMiddleware';
import mfaMiddleware from './mfaMiddleware';
import partialSuccessMiddleware from './partialSuccessMiddleware';

export const middlewares = [
  errorMiddleware,
  loggerMiddleware,
  serverTimingMiddleware,
  mfaMiddleware,
  partialSuccessMiddleware,
];

export type MiddlewareType = (typeof middlewares)[number];

export { default as errorMiddleware } from './errorMiddleware';
export { default as loggerMiddleware } from './loggerMiddleware';
export { default as serverTimingMiddleware } from './serverTimingMiddleware';
export { default as mfaMiddleware } from './mfaMiddleware';
export { default as partialSuccessMiddleware } from './partialSuccessMiddleware';
